import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout for all routes nested under $pinId (plan-root viewer variant).
// PlanViewerNew renders the pin independently via useParams({ strict: false }).
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId'
)({
  component: () => <Outlet />
})
